import { createSlice } from "@reduxjs/toolkit";

interface RootState {
  mainOrbit: any;
  selectOrbit: any;
  maps: number;
  adminStuff: boolean;
  orbitRotate: boolean;
  orbitSearch:any;
  header:boolean
  volunteersDetails:any
  instriction:any
  hoverPlanet:any;
  orbitAccess:any
}

const initialState: RootState = {
  mainOrbit: null,
  selectOrbit: null,
  maps: 0,
  adminStuff: false,
  orbitRotate: false,
  orbitSearch:'',
  header:true,
  volunteersDetails:null,
  instriction:1,
  hoverPlanet:null,
  orbitAccess:0
};

export const orbitSlice: any = createSlice({
  name: "orbitDetails",
  initialState,
  reducers: {
    setMainOrbit: (state: any, { payload }) => {
      state.mainOrbit = payload;
    },
    setSelectOrbit: (state: any, { payload }) => {
      state.selectOrbit = payload;
    },
    setMaps: (state: any, { payload }) => {
      state.maps = payload;
    },
    setAdminStuff: (state: any, { payload }) => {
      state.adminStuff = payload;
    },
    setOrbitRotate: (state: any, { payload }) => {
      state.orbitRotate = payload;
    },
    setOrbitSearch: (state: any, { payload }) => {
      state.orbitSearch= payload;
    },
    setHeader: (state: any, { payload }) => {
      state.header= payload;
    },
    setVolunteersDetails: (state: any, { payload }) => {
      state.volunteersDetails= payload;
    },
    setInstriction: (state: any, { payload }) => {
      state.instriction= payload;
    },
    setHoverPlanet: (state: any, { payload }) => {
      state.hoverPlanet= payload;
    },
    setOrbitAccess: (state: any, { payload }) => {
      state.orbitAccess= payload;
    },
    

  },
});

export const {
  setMainOrbit,
  setSelectOrbit,
  setMaps,
  setAdminStuff,
  setOrbitRotate,
  setOrbitSearch,
  setHeader,
  setVolunteersDetails,
  setInstriction,
  setHoverPlanet,
  setOrbitAccess,
} = orbitSlice.actions;

export const getOrbitDetails = (state: any) => state.orbitReducer;

export default orbitSlice.reducer;
